import {AccessRole} from 'models/access-role';
import {AccessGroup} from 'models/access-group';
import {AccessRolePermission} from 'models/access-role-permission';
import {Agent} from './base';

export class AccessAgent {
    roles = new Agent(AccessRole, '/access/roles');
    permissions = new Agent(AccessRolePermission, '/access/permissions');
    groups = new Agent(AccessGroup, '/access/groups');
}
